export default __webpack_public_path__ + "static/PRO BONO-19acd9359b124796597dc564bd07ee49.svg";